import PropTypes from 'prop-types';

const propTypesWeb = {
  fromBagPage: PropTypes.bool.isRequired,
  plpLabels: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  keepAlive: PropTypes.bool.isRequired,
  outOfStockLabels: PropTypes.shape({}).isRequired,
  isFavoriteEdit: PropTypes.bool.isRequired,
  currentProduct: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  selectedColorProductId: PropTypes.number.isRequired,
  isOutfitPage: PropTypes.bool.isRequired,
  selectColor: PropTypes.string.isRequired,
  isGiftCard: PropTypes.bool.isRequired,
  showColorChips: PropTypes.bool.isRequired,
  quickViewColorSwatchesCss: PropTypes.string.isRequired,
  isPDP: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  imagesByColor: PropTypes.shape({}).isRequired,
  relatedSwatchImages: PropTypes.shape({}).isRequired,
  isMultiItemQVModal: PropTypes.bool.isRequired,
  itemBrand: PropTypes.string.isRequired,
  selectFit: PropTypes.func.isRequired,
  selectedFit: PropTypes.shape({}).isRequired,
  className: PropTypes.string.isRequired,
  hideAlternateSizes: PropTypes.shape([]).isRequired,
  onCloseClick: PropTypes.func,
  isFromBagProductSfl: PropTypes.bool.isRequired,
  isPickup: PropTypes.bool.isRequired,
  sizeChartLinkVisibility: PropTypes.number.isRequired,
  isErrorMessageDisplayed: PropTypes.bool.isRequired,
  selectSize: PropTypes.func.isRequired,
  isDisableZeroInventoryEntries: PropTypes.bool.isRequired,
  sizeChartDetails: PropTypes.string.isRequired,
  isSKUValidated: PropTypes.bool.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  quantityList: PropTypes.shape([]).isRequired,
  fitChanged: PropTypes.bool.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  isPlcc: PropTypes.bool.isRequired,
  currencyAttributes: PropTypes.shape({}).isRequired,
  isCanada: PropTypes.bool.isRequired,
  isInternationalShipping: PropTypes.bool.isRequired,
  listPrice: PropTypes.string.isRequired,
  offerPrice: PropTypes.string.isRequired,
  displayErrorMessage: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  setAnalyticsData: PropTypes.func.isRequired,
  showAddedToBagCta: PropTypes.bool.isRequired,
  revertAtbButton: PropTypes.func.isRequired,
  addedToBagLabel: PropTypes.string.isRequired,
  selectedSize: PropTypes.string.isRequired,
  unbxdId: PropTypes.string.isRequired,
  selectedQuantity: PropTypes.number.isRequired,
  hideStickyABTest: PropTypes.func.isRequired,
  isBundleProduct: PropTypes.bool.isRequired,
  errorOnHandleSubmit: PropTypes.func.isRequired,
  showAddToBagCTA: PropTypes.bool.isRequired,
  alternateSizes: PropTypes.shape([]).isRequired,
  isATBErrorMessageDisplayed: PropTypes.bool.isRequired,
  quickViewPickup: PropTypes.func.isRequired,
  outfitCarouselAddedToBagMsgDispatch: PropTypes.func.isRequired,
  storeId: PropTypes.string.isRequired,
  sizeList: PropTypes.shape([]).isRequired,
  fitList: PropTypes.shape([]).isRequired,
  colorList: PropTypes.shape([]).isRequired,
  colorFitSizeDisplayNames: PropTypes.shape([]).isRequired,
  addedTobagMsgDispatch: PropTypes.shape([]).isRequired,
  addBtnMsg: PropTypes.bool.isRequired,
  hasLoyaltyAbTestFlag: PropTypes.bool,
  showOutfitCarouselAddedCTA: PropTypes.bool,
  outfitCarouselState: PropTypes.bool,
  isOutfitCarousel: PropTypes.bool,
  isEnabledOutfitAddedCTA: PropTypes.bool,
  showAddtoBagDrawer: PropTypes.bool,
  revertCarouselAtbButton: PropTypes.func.isRequired,
  generalProductId: PropTypes.string,
  productDetailsToPath: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  initialMultipackMapping: PropTypes.shape([]).isRequired,
  TCPStyleType: PropTypes.string.isRequired,
  setSelectedMultipack: PropTypes.func,
  isStyleWith: PropTypes.bool,
  pdpLabels: PropTypes.instanceOf(Object).isRequired,
  getDetails: PropTypes.shape({}).isRequired,
  onQuickViewOpenClick: PropTypes.func.isRequired,
  fromPDP: PropTypes.bool.isRequired,
  selectedMultipack: PropTypes.string.isRequired,
  TCPStyleQTY: PropTypes.number.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  isPhysicalMpackEnabled: PropTypes.bool,
  imageSwatchesToDisplay: PropTypes.shape([]).isRequired,
  isImageSwatchDisabled: PropTypes.bool,
  isNewQVEnabled: PropTypes.bool,
  isNewPDPEnabled: PropTypes.bool,
  isABTestLoaded: PropTypes.bool,
  setStickyFooterState: PropTypes.func.isRequired,
  checkForOOSForVariant: PropTypes.bool.isRequired,
  isRecommendationAvailable: PropTypes.bool,
  closePickupModal: PropTypes.func.isRequired,
  otherAvailableSizeLabel: PropTypes.string,
  selectColorToHover: PropTypes.func,
  selectColorToHoverOut: PropTypes.func,
  TCPMultipackProductMapping: PropTypes.shape([]).isRequired,
  singlePageLoad: PropTypes.bool.isRequired,
  setInitialTCPStyleQty: PropTypes.bool.isRequired,
  resetProductDetailsDynamicData: PropTypes.shape([]).isRequired,
  setInitialQuickViewLoad: PropTypes.bool.isRequired,
  getQickViewSingleLoad: PropTypes.func.isRequired,
  addToBagErrorId: PropTypes.string,
  disableMultiPackTab: PropTypes.bool.isRequired,
  getDisableSelectedTab: PropTypes.func.isRequired,
  newColorList: PropTypes.shape([]),
  initialFormValues: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}).isRequired,
  formValues: PropTypes.shape({}),
  onPickUpOpenClick: PropTypes.func,
  hideMultipackPills: PropTypes.bool,
  disableSwappingMpackPills: PropTypes.bool,
  productInfoFromBag: PropTypes.shape({}),
  availableTCPmapNewStyleId: PropTypes.shape([]),
  isAfterPayDisplay: PropTypes.bool,
  pdpUrlFromBag: PropTypes.string,
  quickViewLabels: PropTypes.shape({
    addToBag: PropTypes.string,
    viewProductDetails: PropTypes.string,
  }).isRequired,
  goToPDPPage: PropTypes.func,
  /** User's preferred store information */
  userDefaultStore: PropTypes.shape({
    basicInfo: PropTypes.shape({
      /** store id identifier */
      id: PropTypes.string.isRequired,
      /** store Name */
      storeName: PropTypes.string.isRequired,
    }).isRequired,
  }),
  showPickupInfo: PropTypes.bool,
  labels: PropTypes.shape({
    lbl_Product_pickup_BOPIS_AVAILABLE: PropTypes.string,
    lbl_Product_pickup_BOPIS_DISABLED_FITS_HUSKY: PropTypes.string,
    lbl_Product_pickup_BOPIS_DISABLED_FITS_PLUS: PropTypes.string,
    lbl_Product_pickup_BOPIS_DISABLED_FITS_SLIM: PropTypes.string,
    lbl_Product_pickup_BOPIS_ONLY_AVAILABLE: PropTypes.string,
    lbl_Product_pickup_BOSS_AVAILABLE: PropTypes.string,
    lbl_Product_pickup_BOSS_ONLY_AVAILABLE: PropTypes.string,
    lbl_Product_pickup_FIND_STORE: PropTypes.string,
    lbl_Product_pickup_FREE_SHIPPING: PropTypes.string,
    lbl_Product_pickup_NO_MIN_PURCHASE: PropTypes.string,
    lbl_Product_pickup_PICKUP_IN_STORE: PropTypes.string,
    lbl_Product_pickup_PRODUCT_BOPIS: PropTypes.string,
    lbl_Product_pickup_TITLE_DEFAULT_NOSTORE: PropTypes.string,
    lbl_Product_pickup_CHANGE_STORE: PropTypes.string,
  }),
  onPickupClickAddon: PropTypes.func,
  socialProofMessage: PropTypes.string,
  isFamilyOutfitEnabled: PropTypes.bool,
  pdpProductDetails: PropTypes.shape({}),
  onAddItemToFavorites: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  wishList: PropTypes.func,
  resetCountUpdate: PropTypes.func,
  countUpdated: PropTypes.bool,
  isPerUnitPriceEnabled: PropTypes.bool,
  isBrierleyPromoEnabled: PropTypes.bool,
  onSetLastDeletedItemIdAction: PropTypes.func,
  deleteFavItemInProgressFlag: PropTypes.bool,
  productDetailsPDP: PropTypes.shape({}),
  productInfo: PropTypes.shape({}),
  AddToFavoriteErrorMsg: PropTypes.string,
  removeAddToFavoritesErrorMsg: PropTypes.func,
  hidePriceDisplay: PropTypes.bool,
  getGiftCardValue: PropTypes.string,
  isShowBrandNameEnabled: PropTypes.bool,
  openModal: PropTypes.func,
  setIsBopisSelected: PropTypes.func,
  breadCrumbs: PropTypes.string,
  trackClickDispatch: PropTypes.func,
  addToPickupError: PropTypes.string,
  setAddToPickupError: PropTypes.func,
  isOpenAddedToBag: PropTypes.bool,
  handleRatingClick: PropTypes.func,
  isBopisFilterOn: PropTypes.bool.isRequired,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  resetSimilarProductsActn: PropTypes.func,
};

const defaultPropsWeb = {
  productDetailsToPath: '',
  generalProductId: '',
  isEnabledOutfitAddedCTA: false,
  isOutfitCarousel: false,
  outfitCarouselState: false,
  showAddtoBagDrawer: false,
  showOutfitCarouselAddedCTA: false,
  isPDP: false,
  hasLoyaltyAbTestFlag: false,
  setSelectedMultipack: () => {},
  isStyleWith: false,
  isPhysicalMpackEnabled: true,
  isImageSwatchDisabled: false,
  isNewQVEnabled: false,
  isNewPDPEnabled: false,
  isABTestLoaded: false,
  isRecommendationAvailable: false,
  otherAvailableSizeLabel: '',
  selectColorToHover: () => {},
  selectColorToHoverOut: () => {},
  addToBagErrorId: '',
  newColorList: [],
  formValues: {},
  onPickUpOpenClick: () => {},
  hideMultipackPills: false,
  disableSwappingMpackPills: false,
  productInfoFromBag: {},
  availableTCPmapNewStyleId: [],
  isAfterPayDisplay: false,
  pdpUrlFromBag: '',
  goToPDPPage: () => {},
  userDefaultStore: {
    basicInfo: {
      id: '',
      storeName: '',
    },
  },
  showPickupInfo: false,
  labels: {
    lbl_Product_pickup_BOPIS_AVAILABLE: 'Pick up TODAY!',
    lbl_Product_pickup_BOPIS_DISABLED_FITS_HUSKY: 'husky',
    lbl_Product_pickup_BOPIS_DISABLED_FITS_PLUS: 'plus',
    lbl_Product_pickup_BOPIS_DISABLED_FITS_SLIM: 'slim',
    lbl_Product_pickup_BOPIS_ONLY_AVAILABLE: 'Item available for pickup TODAY',
    lbl_Product_pickup_BOSS_AVAILABLE: 'Or choose NO RUSH Pickup ',
    lbl_Product_pickup_BOSS_ONLY_AVAILABLE: 'Choose NO RUSH Pickup ',
    lbl_Product_pickup_FIND_STORE: 'Find In Store',
    lbl_Product_pickup_FREE_SHIPPING: 'FREE Shipping Every Day!',
    lbl_Product_pickup_NO_MIN_PURCHASE: 'No Minimum Purchase Required.',
    lbl_Product_pickup_PICKUP_IN_STORE: 'PICK UP IN STORE',
    lbl_Product_pickup_PRODUCT_BOPIS: 'Select Store',
    lbl_Product_pickup_TITLE_DEFAULT_NOSTORE: 'Select Store',
    lbl_Product_pickup_CHANGE_STORE: '(Change Store)',
    lbl_Product_pickup_UNAVAILABLE_IN_STORES: 'UNAVAILABLE IN STORES',
  },
  onPickupClickAddon: () => {},
  socialProofMessage: '',
  isFamilyOutfitEnabled: false,
  pdpProductDetails: {},
  onAddItemToFavorites: () => {},
  isLoggedIn: false,
  wishList: () => {},
  resetCountUpdate: () => {},
  countUpdated: false,
  isPerUnitPriceEnabled: false,
  isBrierleyPromoEnabled: false,
  onSetLastDeletedItemIdAction: () => {},
  deleteFavItemInProgressFlag: false,
  productDetailsPDP: {},
  productInfo: {},
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  hidePriceDisplay: false,
  getGiftCardValue: '',
  isShowBrandNameEnabled: false,
  openModal: () => {},
  setIsBopisSelected: () => {},
  breadCrumbs: '',
  trackClickDispatch: () => {},
  addToPickupError: '',
  setAddToPickupError: () => {},
  isOpenAddedToBag: false,
  onCloseClick: () => {},
  handleRatingClick: () => {},
  isNewPJPPDPRedesignEnabled: false,
  resetSimilarProductsActn: () => {},
};

export { propTypesWeb, defaultPropsWeb };
